import React from "react";
import { connect } from "react-redux";
import ContentCarouselContainer from "../../blog/components/content-carousel/content-carousel-container";
import "../css/dlp-carousel.less";

const dlpCarousel = props => {
  const { tags } = props;

  if (!tags || tags.length === 0) return null;

  return (
    <div className="dlp-related-articles">
      <ContentCarouselContainer header="Recommended articles" tags={tags} />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    tags: state.slugInfo.tags
  };
};

export default connect(mapStateToProps)(dlpCarousel);
